import sanityClient from "@sanity/client";

export default sanityClient({ projectId: "xsb8mb3b", dataset: "production" });
